var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.3536,
    y1: 0.353553,
    x2: 0.353553,
    y2: 13.3536,
    stroke: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineSmall);
export default __webpack_public_path__ + "static/media/line-small.d12ac3f83ff371cfd69e31d104da5e9a.svg";
export { ForwardRef as ReactComponent };